import * as React from 'react';
import { observer, inject } from 'mobx-react';
import styled from '@emotion/styled';
import { Tabs, Tab, Card } from '@blueprintjs/core';
import { UserStore } from '../../store/UserStore';
import { LocaleStore } from '../../store';
import { User } from '../../store/models/User';
import { RouteComponentProps } from 'react-router-dom';
import { TLCode } from '../../common/enums';
import { Instance } from 'mobx-state-tree';
import MainSectionLayout from '../layout/MainSectionLayout';
import { css } from 'emotion';
import withTranslate, { WithTranslateProps } from '../common/WithTranslate';
import UserForm from './UserForm';

interface UserPageProps extends RouteComponentProps<{ id: string }> {
  LocaleStore?: Instance<typeof LocaleStore>;
  UserStore?: Instance<typeof UserStore>;
}

interface UserPageState {
  user: Instance<typeof User> | undefined;
  isLoading: boolean;
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const CardStyle = css({
  height: '100%',
});

@inject('UserStore')
@observer
class UserPage extends React.Component<UserPageProps & WithTranslateProps, UserPageState> {
  state = {
    isLoading: false,
  } as UserPageState;

  _isMounted = false;

  async fetchData() {
    const { UserStore } = this.props;
    const userId = parseInt(this.props.match.params.id, 10);
    this._isMounted && this.setState({ isLoading: true });
    if (userId > 0) {
      await UserStore!.loadElement(userId);
      const user = UserStore!.getById(userId);
      this._isMounted && this.setState({ user });
    }
    this._isMounted && this.setState({ isLoading: false });
  }

  async componentDidMount() {
    this._isMounted = true;
    await this.fetchData();
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  componentDidUpdate(prevProps: UserPageProps, prevState: UserPageState) {
    if (prevProps.match.params.id !== this.props.match.params.id) {
      this.fetchData();
    }
  }

  renderTitle = () => {
    const user = this.state.user;
    return user !== undefined ? (
      <h1>{user!.firstName + ' ' + user!.lastName}</h1>
    ) : (
      <h1>{this.props.translate(TLCode.AddUser)}</h1>
    );
  };

  save = (data: any) => {
    this.props.UserStore!.saveUser(data);
  };

  public render() {
    const { isLoading, user } = this.state;
    const { translate } = this.props;

    return (
      <MainSectionLayout isLoading={isLoading} renderHeader={this.renderTitle}>
        <Container>
          <Card className={CardStyle.toString()}>
            <Tabs id="main" selectedTabId="profile">
              <Tab
                id="profile"
                title={translate(TLCode.USER_Title)}
                panel={<UserForm user={user} save={this.save} />}
              />
            </Tabs>
          </Card>
        </Container>
      </MainSectionLayout>
    );
  }
}

export default withTranslate(UserPage);
